import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { MailService } from '@app/services/shared/mail.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { ConfirmationService, MessageService } from 'primeng/api';
import { catchError, EMPTY, firstValueFrom, switchMap, throwError } from 'rxjs';
import { CampaignService } from '@app/services/campaigns/campaign.service';
@Component({
  selector: 'app-mail',
  templateUrl: './mail.component.html',
  styleUrls: ['./mail.component.css']
})
export class MailComponent implements OnInit, OnChanges, OnDestroy {
  @Input() memberlist: any;
  @Output() closeEmail: EventEmitter<any> = new EventEmitter();
  text;
  result;
  mailform;
  
  subscriptions: Subscription[] = [];
  nomailcount;
  emailaddresses;
  toAddresses: string[] = [];
  to: string[] = [];
  fileData: File = null;
  attachments: File[] = [];
  emailaddress;
  btnDisabled: boolean = false;
  institutionId;
  memberidlist: number[] = [];
  memberlist1: any;
  constructor(
    private fb: FormBuilder,  
    private confirmationService: ConfirmationService,
    private mailService: MailService,
    private messageService: MessageService,
    private permissionService: PermissionsService,
    private campaignService: CampaignService) { }

  ngOnInit() {
    this.mailform = this.fb.group({
      to: ['', Validators.required],
      from: ['', ''],
      subject: ['', Validators.required],
      msg: ['', Validators.required]
    });
      
    this.permissionService.selectedrole.subscribe(r => {
      
        if (r.institution.shortName == "SL1" && r.officeEmail != null) {
          this.emailaddress = r.officeEmail;
        } else {
          this.emailaddress = r.institutionEmail;

        }
        this.institutionId = r.institution.id;

      this.mailform.patchValue({ from: this.emailaddress ?? "noreply@oddfellow.se" });

    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.memberidlist = [];
    this.to = [];
    this.memberlist1 = [];
    if (changes.memberlist) {
      this.nomailcount = this.memberlist.filter(m => !m.email1).length;
     
      this.memberlist1 = this.memberlist.filter(m => m.email1);
    
    
    }
   
    
   
    for (let x = 0; x < this.memberlist1.length; x++) {
      this.memberidlist.push(this.memberlist1[x].id ? this.memberlist1[x].id : this.memberlist1[x].memberId);
    }
   
    
    this.mailService.GetEmailAddresses(this.memberidlist).subscribe(response => {
      if (response) {
        this.emailaddresses = response;
        for (let x = 0; x < this.emailaddresses.length; x++) {
          if (this.emailaddresses[x].email) {
            this.to.push(this.emailaddresses[x].email);
          }
        }
        this.mailform.get('to').setValue(this.to.toString().replace(/,/g, ';'));
      }
    });
  }

  validateEmail(email) {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase());
  }

  copyText() {
    const textArea = document.createElement('textarea');
    textArea.value = this.mailform.value.to;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    this.messageService.add({ severity: 'info', summary: 'Information', detail: 'Mailadresserna har kopierats till urklipp.' });
  }


  getEmailAddressForSender(senderid: number) {
   
    this.mailService.GetEmailAddresses([senderid]).subscribe(response => {
      if (response) {
        console.log('email: ', response[0].email);
        return response[0].email;
      }
    });
  }

  async postEmail() {
    this.mailform.setErrors({ formError: true });
    const msgtext = this.mailform.get('msg').value;
    this.text = this.replaceAll(msgtext, '<br>', '');
    this.text = this.replaceAll(this.text, '<p>', '');
    this.text = this.replaceAll(this.text, '</p>', '<br>');

    const addresses = this.mailform.get('to').value.split(';');
    const incorrectEmailAddresses = [];
    this.toAddresses = [];

    for (let x = 0; x < addresses.length; x++) {
      const address = addresses[x].trim();
      if (!this.validateEmail(address)) {
        incorrectEmailAddresses.push(address);
      } else {
        this.toAddresses.push(address);
      }
    }

    if (incorrectEmailAddresses.length > 0) {
      this.showInfoDialog(incorrectEmailAddresses);
      return;
    }

    const sender = JSON.parse(localStorage.getItem('claims') ?? '{}');
    const response = await firstValueFrom(this.mailService.GetEmailAddresses([sender.id]));
    const senderEmail = response?.[0]?.email ?? '';
    const campaignId = crypto.randomUUID();
    const formData = new FormData();
    formData.append('subject', this.mailform.get('subject').value);
    formData.append('message', this.text);
    formData.append('toAddresses', this.toAddresses.toString());
//formData.append('toAddresses', addresses.toString());
    formData.append('fromAddress', this.mailform.get('from').value);
    formData.append('sender', sender.givenName + ' ' + sender.familyName + ' (' + sender.id + ')' + ' ' + senderEmail);
    formData.append('senderEmail', senderEmail);
    formData.append('campaignId', campaignId);

    for (const a of this.attachments) {
      formData.append('attachments', a);
    }

    this.mailService.SendEMail(formData).pipe(
  switchMap(response => {
    if (!response) {
      return throwError(() => new Error('E-post kunde inte skickas.'));
    }

    return this.campaignService.addCampaign({
      id: campaignId,
      subject: this.mailform.get('subject')?.value,
      institutionId: this.institutionId,
      senderId: sender.id,
      senderName: `${sender.givenName} ${sender.familyName}`,
      senderEmail: senderEmail,
      numberOfRecipients: this.toAddresses.length
      // numberOfRecipients: addresses.length
     
    });
  }),

  switchMap(() => {
    return this.mailService.addRecipientsToCampaign({
      CampaignId: campaignId,
      ToAddresses: this.toAddresses,
      //ToAddresses: addresses,
      MemberIdList: this.memberidlist
    });
  }),

  catchError(error => {
    console.error('Fel vid utskick:', error);

    this.messageService.add({
      severity: 'error',
      summary: 'Fel',
      detail: 'Ett fel uppstod när e-postmeddelandet skulle skickas.'
    });

    return EMPTY;
  })
).subscribe(() => {
  this.messageService.add({
    severity: 'success',
    summary: 'Information',
    detail: 'Epost skickat.'
  });

  this.cancel();
});
   /* this.mailService.SendEMail(formData).subscribe(response => {
      if (response) {
        
        this.campaignService.addCampaign({
          id: campaignId,
          subject: this.mailform.get('subject').value,
          institutionId: this.institutionId,
          senderId: sender.id,
          senderName: sender.givenName + ' ' + sender.familyName,
          senderEmail: senderEmail,
          numberOfRecipients: this.toAddresses.length
        }).subscribe(_resp => {
          this.mailService.addRecipientsToCampaign({
            CampaignId: campaignId, 
            ToAddresses: this.toAddresses,
            MemberIdList: this.memberidlist}).subscribe(_resp2 => {
            this.messageService.add({ severity: 'success', summary: 'Information', detail: 'Epost skickat.' });
            this.cancel();
          });
        });
      }
    });*/
  }

  replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
  }

  showInfoDialog(addresses: any): void {
    let alist = '';
    for (const a of addresses) {
      alist += a + '<br>';
    }
    alist = '<strong>' + alist + '</strong>';
    let noemail1 = [];
    for (const m of this.memberlist) {
      if (!m.email1) {
        noemail1.push(m);
      }
    }
    let noemails = '';
    if (noemail1.length > 0) {
      noemails = '<br>Följande medlemmar saknar email1:<br>';
      for (const member of noemail1) {
        noemails += member.id + ' ' + member.givenName + ' ' + member.familyName;
      }
    }
    alist = alist + noemails;

     this.confirmationService.confirm({
      header: 'Information',
      message: 'Nedanstående epostadresser är felaktiga: <br>' + alist,
      acceptLabel: 'Ok',
      rejectVisible: false,
      accept: () => {
        
      },
      reject: () => {
      }
    });
  }

  cancel() {
    this.closeEmail.emit();
  }

  fileProgress(fileInput: any) {
    for (const f of fileInput.target.files) {
      this.attachments.push(<File>f);
    }
  }

  drop(evt: any) {
    evt.preventDefault();
  }

  allowDrop(evt: any) {
    evt.preventDefault();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(x => {
      x.unsubscribe();
    });
  }

  removeAttachment(file: File) {
    this.attachments = this.attachments.filter(f => f.name !== file.name || f.size !== file.size);
  } 

}
